const {MerkleTree} = require('merkletreejs') ;
const keccak256 = require('keccak256')

module.exports.isog = function IsOg(address){
    console.log("isog called")
    const addresses = [
"0x902d50F471f37AcBf778A1BB232157362e667C71",
"0xF6D64A23ce944B56EdB2Cb582d3715f88b1308b2",
"0x444604b3A92356d5a92A745E037A6bdaBe8d22dA",
"0x7bA5009EB75b45438630d2Cb91cc91d21eC7385f",
"0x36d57C719dD024e55E37AF46003C9F04E87eBC37",
"0x8130Bcf0b115dF9deAB08cF22391c6211f033728",
"0x7610210F7eA9D1EFB2641081794dAB91a4C60395",
"0x4fDd628711acD97281BFD06a53920eba86720A2E",
"0x6066792abec35de688c91bd7d812AC47De16d67f",
"0xb536AE9273FB16DF486C165aC5c77E6d6A285dC4",
"0xF81B1248DdCB740974Ae9bc0A3b98426A2FC5731",
"0x6189206861F3373084D211b67D713509b1DCA64f",
"0x58B59c4D970345C9484A4cEb4E5357B294A3aD84",
"0xBB37CFD96C17EFDe6C18A144eAa0b53626fCAD18",
"0x8960BBD1dC9dd1E793efbCbc2cEA06F14b6b0f0C",
"0xb34ED46Bf3629bdDfbFC8a0D6154Ae1Ad4E119e6",
"0x8f359F47a468de37B8c63f20CB61c4CD495DA1F5",
"0x9CA409Fd726A06356A07AA7756f2A86B1C7D4e7d",
"0xdFd50be2946281327e4Ee36CdB7c1A3E165C8AA0",
"0x9457329A3f22D6d31E0810ebf616546eB20a9035",
"0xfa7B2d078F20505Ffc4CA3Bb55cb96a94812cFE8",
"0x016B8ea574e3a0e27D4b651D332c8c7d94b89B8c",
"0x323166a31A1cD787a7dcDa76C08c28F2AcC02160",
"0x6d9399cABFe303E6cd70F8F3d5EB99661ff992ec",
"0xa69f2954A5dA5C16c99998588Ea626290E887C18",
"0xbAcb0cccB8DAd57f82a459b10a29705C190210EE",
"0x9398Fb58A7b897F9da357f46932Bc7663229eb48",
"0x47F24e183CA1381663096912139Df8Cd1BFcc6b5",
"0xe9B113c1a528464d7d862423FFDC8F9Ca6F88b15",
"0xC8dDbF0Ed5C19F0F40b8276f9905608775A1Bd03",
"0xbD6656d81578a1D12ca9A038D95752b3B450D6b9",
"0xE0B9286cFA4F10b1956f837A09D1E6aB8C5312EF",
"0x1E7A810b8162Dd50EBA2c90065DF4f24678D7928",
"0x68eb484BcFc52B8962CE2D80D8C4f80F58B992cf",
"0xd24a9A9f594b038A6cFb91370BC8014D28201009",
"0x8D3326c5FAcD9ec978DeaFceD2E718Fa7d59fF49",
"0x2bFbbA4E0385F93375587aa37947216ccC68d624",
"0xde6bFe03Ba725724Dfc8325E6C97A9d1e8F9FA81",
"0x88d7A110558d6d8BD98A9f4c25b9f7B2924BcCcB",
"0x4a0f95f9cD4f89A281f795723206B0006F0Cc458",
"0x7b992a545c8ee9472A69179cF87700C6E622BAaa",
"0xA2F396ee4ea57F64FD47bc33674F4bA582fa64D9",
"0x1D35F32431C08c4dfE4df95fa439991f72B0A08e",
"0x7a98fa0CC12E891BAF791A00A1eFAF55Fe004e7a",
"0xB19D17C504bdbc0D9d96322313ac423B7C8461fE",
"0x40d5fE53AE73b98b8D35d582C6B0e01c38823B3e",
"0xC174Ba480E14803fE399a0549Ab48774bed45C72",
"0xCfFbe435F882e6Dcdc33b1e5cBbBE44Eace6c5B1",
"0xa464d2113b1636a7A39a5bF5A0b1c3C9C937aE3e",
"0x85B1B7d7472EB9d05cD9835db94BeFbd34F26a13",
"0xEF428fc7E0B7dd6312dc19Ae3eB3cCE852F9a3bF",
"0xeFAb074f577C6a0d03A208217e472F43E8698714",
"0x2b3BB815C44cDB71EE7d4ed4e7a33f499E586084",
"0xF3EbEf48227a8ccB7Fa376096A97448FbeF41fbe",
"0x3FcA616Bd92deA0CD0034b0c8DA6d3E6557cE99A",
"0x9372AE993be7161F91Bec52Aee86b6d6cac8C406",
"0xC4Ce55Daf4EC621F9Cf6f363acF7B604E4fB60D6",
"0x092F190a527A5De46ea2515AEe748b87094A6CB5",
"0x602ABEeB01D3C839B7d093DAD299Ad157cb4f12f",
"0x0f7E1Ef35F822552597FE9d2Eb44EBb00Bd01557",
"0x5Fc27d746C9F3D36C4d9Cf0F0a80ebB477F34E6D",
"0xC063E1712eb7Df04876cB375c9Cf84da1A6e49a2",
"0xB5AB2D2CE88374B8995FE4cE1407B4BE72a9ba26",
"0x89DE1c7069f48c04152179EcB789F98864C0D5c9",
"0x255e05f768cCE5D9bc49216b0fef7e2a79F3b73B",
"0x9a52b7392A33702F8999AE8c03e36Ce498EBB0fE",
"0xe0451E299b949BCF8b46a70b40d811B35a648b56",
"0x79e5b3A11e774B45EA345d66f73d70430a1cb923",
"0x77278997D32a4da8921fB26a7346F8877091d704",
"0x62e9e01D6f53D921d66662fa7B61d2C34745aDb3",
"0x61608D7Ef8b26BFE137948331e7D013E7F8271cf",
"0xE36Ece0Cf327b8d091FAEDB6E7F559D5854F110f",
"0xC907768bd3955173b3900f34978A8778982FfDaf",
"0x389FEB9Da36ADA8c2bB692467D751f62e4821b24",
"0x1F82Fd59071aa58E03800bd586E6D2f9CD5fe325",
"0x8D3326c5FAcD9ec978DeaFceD2E718Fa7d59fF49",
"0x45A16BE1a81A41A745d54fCD0801c528AdE50f4d",
"0x4Ecedc066f15C40edc7F9E185b5CdA6bd229e13e",
"0x0c23abD530F089977899279A6006eF70f9c8A31B",
"0xA49E0Bb000E449ffea0BdF8965b92804466cF16D",
"0x400aB604DF5501A3e761b0D3CEb18d1742fC2ECC",
"0x5526Af4213cF071cf059e70Aa71Af37b86F14e7E",
"0x01082fE0EfF957B4BC9Ca8CAbA1b25882abea724 ",
"0xfFd4C9550E4D336D2e43cf3FA7ADfA9Cc04d18fb",
"0x3B189b0BB1C7f1c68ADD9dfBc7885e3E27d4Ac9E",
"0x451c58c0d9A33e291135044Bf1D424702C58c387",
"0x7c8dc06B97694Bef65734C3c4Acd71F1F4955f73",
"0x2B7B98bB01E33851a3841fD8c7eb22C8Ebf0b676",
"0x500bEA1E1DdF98CABA5EBCa9d289344eE9422a39",
"0xda485b890e6C44e3B5da7Df953CB0f5B4fe5A743",
"0x2F1532fB2aA8712B750dDbbC2f8511FE178ADf64",
"0xf7dB909480fbf82c6B88d88Bc58Da2947b511c46",
"0xC64d7F109Baa4556BD485F2F8333353301A4695d",
"0x43D9eD45Bc6931661402fce8FFe1590413185e21",
"0x719a7aD45Ab2FFBAc941826888cD95A00F34a78f",
"0x9F8909c8bd043a37566a8256BeEd7b853e7e1D96",
"0x51182759B5dFD73430F131743228a9e4d5E6d23F",
"0xaC3e6198524E7c2fd793D98643C2e6C79eF0F516",
"0xD662EEa026B8B64c9DE19a4C5aDa169843215e99 ",
"0x3ea49c578549011e2f09Ea855e35B6BC2D54395a",
"0xd087C11D6C20431CC89909AdF70F08D3BEe0C548",
"0x1721BA87CC206Eaec114dfCB2146C09552cd8649",
"0x8dB0269CDC93283d10CE230C2bEA46636d4e399b",
"0xF53a1d42d43926aAa55788811D6F23bb204fBC83"]


    const leaves = addresses.map(x => keccak256(x))
console.log("Size "+ leaves.length)
const tree = new MerkleTree(leaves, keccak256, { sortPairs: true })
const buf2hex = x => '"0x' + x.toString('hex')

console.log("Root " + buf2hex(tree.getRoot()))

const leaf = keccak256(address)
console.log("Leaf "+buf2hex(leaf))
const proof = tree.getProof(leaf).map(x => buf2hex(x.data))
console.log("Proof " +JSON.stringify(proof)) 


const status = proof.length === 0;
return {'status': status, 'proof': proof}

}




